<template>
  <div class="hm-card landing start">
    <div class="background-container">
      <div class="max-w pills">
      </div>
    </div>
    <div class="max-w">
      <div class="header">
        <h1>Could You Save on Rx Costs with Medicare Extra Help?</h1>
        <h2>Over 50% of those who apply are approved!</h2>
        <p>Pay as little as $1.25 for generics and $3.80 for brand‑name drugs.*</p>
        <div class="calculator">
          <img class="img" src="//hm-lis.herokuapp.com/img/svg/calculator.svg" alt="image">
          <p>With HealthMarkets’ Extra Help Calculator, find out if you are eligible today!</p>
        </div>
        <SuiButton color="orange" content="Get Started" @click="() => goNextStep('medicaid')"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Start from '@/components/small/Start';

  export default {
    extends: Start,
  }
</script>

<style lang="scss" scoped>

  button.green {
    padding: 1.25em;
    &.article {
      padding: 1em;
    }
  }

</style>
